// extracted by mini-css-extract-plugin
export var changeIcon = "_4n-4";
export var container = "_4n-0";
export var divider = "_4n-7";
export var externalLinkIcon = "_4n-1";
export var green = "_4n-5";
export var helpCircleIcon = "_4n-3";
export var iconButton = "_4n-2";
export var red = "_4n-6";